/**
 * Options + copy for the public "Request a demo" web page.
 *
 * Mirror of the mobile app's `demoRequestConstants.ts` + `en.js` keys.
 */

export const DEMO_ROLE_OPTIONS = [
  { value: "Professor", label: "Professor" },
  { value: "Associate Professor", label: "Associate Professor" },
  { value: "Lecturer", label: "Lecturer" },
  { value: "Clinical Tutor", label: "Clinical Tutor" },
  { value: "Course Coordinator", label: "Course Coordinator" },
];

export const DEMO_TEACHING_AREA_OPTIONS = [
  {
    value: "Histology",
    label: "Histology",
    hint: "Microscopy, tissue structure, and slide-based teaching workflows.",
  },
  {
    value: "Pathology",
    label: "Pathology",
    hint: "Disease mechanisms, specimens, and diagnostic teaching content.",
  },
  {
    value: "Anatomy",
    label: "Anatomy",
    hint: "Structural anatomy, dissection support, and spatial learning.",
  },
  {
    value: "Physiology",
    label: "Physiology",
    hint: "Systems, functions, and applied physiological concepts.",
  },
  {
    value: "Medical Sciences",
    label: "Medical Sciences",
    hint: "Broader preclinical and integrated medical science programs.",
  },
  {
    value: "Other",
    label: "Other",
    hint: "Another discipline — we will tailor the demo to your field.",
  },
];

export const DEMO_CLASS_SIZE_OPTIONS = [
  { value: "<50", label: "<50" },
  { value: "50–150", label: "50–150" },
  { value: "150–300", label: "150–300" },
  { value: "300+", label: "300+" },
];

export const DEMO_MAIN_INTEREST_OPTIONS = [
  { value: "All", label: "All" },
  { value: "Interactive slides", label: "Interactive slides" },
  { value: "Quiz & assessments", label: "Quiz & assessments" },
  { value: "Student engagement tracking", label: "Student engagement tracking" },
  { value: "Ready-made content", label: "Ready-made content" },
  { value: "Custom content creation", label: "Custom content creation" },
  { value: "Exam prep tools", label: "Exam prep tools" },
];

export const DEMO_MAIN_GOAL_OPTIONS = [
  { value: "All", label: "All" },
  { value: "Save preparation time", label: "Save preparation time" },
  { value: "Improve engagement", label: "Improve engagement" },
  { value: "Better exam results", label: "Better exam results" },
  { value: "Standardize teaching", label: "Standardize teaching" },
  { value: "Hybrid/remote teaching", label: "Hybrid/remote teaching" },
];

export const DEMO_PILOT_OPTIONS = [
  { value: "yes", label: "Yes, I am interested" },
  { value: "maybe", label: "Maybe later" },
  { value: "not_now", label: "Not right now" },
];

/** Role → area → class → interest → goal → contact → pilot (no slot picker). */
export const TOTAL_STEPS = 7;

export const DEMO_MAX_SLOT_SELECTIONS = 1;

export const STEP_TITLES = [
  "Your role",
  "Teaching area",
  "Typical class size",
  "Main interest",
  "Main goal",
  "Contact details",
  "Pilot program",
];

export const STEP_SUBTITLES = [
  "Takes about a minute • Tailored to your course",
  "Choose the subject you mainly teach",
  "Helps us size the demo for your cohort",
  "What you want to explore in Microlab",
  "Your biggest teaching priority right now",
  "We will contact you at this address very soon to schedule your demo",
  "Optional pilot for your students",
];

export const COPY = {
  pageTitle: "Request a demo",
  forProfessorsBanner:
    "These demos are intended for faculty members and teaching teams and are not available to students at this time.",
  stepOf: (current, total) => `Step ${current} of ${total}`,
  microcopy: "Takes about a minute • Tailored to your course",
  hintOneSlot:
    "Pick the one time that works best for you. We show the next 3 weeks; greyed-out slots are already booked by someone else.",
  rescheduleViaEmail:
    "If these times do not work for you, we can reschedule via email after you submit.",
  fullyBooked:
    "We are fully booked for this month. Please check back later or contact us at support.",
  pickOneSlot: "Please choose a demo time slot.",
  pickPilotOption:
    "Please choose an option for the free pilot before finishing.",
  selectedSlot: "Your selected time",
  slotBooked: "Booked",
  slotJustTaken:
    "This time was just booked by someone else. Please pick a different slot.",
  workEmail: "Work email",
  phoneOptional: "Phone or WhatsApp (optional)",
  firstName: "First name",
  lastName: "Last name",
  universityOptional: "University / institution (optional)",
  continue: "Continue",
  finish: "Finish",
  back: "Back",
  invalidEmail: "Please enter a valid work email.",
  appleRelayBlocked:
    "Please use your institutional/work email. Apple relay emails are not accepted.",
  submitError: "Could not submit. Please try again in a moment.",
  successTitle: "Thank you",
  successBody:
    "Thank you for your interest in Microlab. We have received your demo request and will contact you very soon by email to schedule a convenient time. We look forward to speaking with you.",
};
